module.exports = __webpack_public_path__ + "img/platinum.6dea10ee.svg";